import React from 'react';
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch, } from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'
import Ws from '../providers/Ws';

export default class ListTimpiLucru extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            strSearchString: '',
            elementeAfisate: []

        }
    }



    componentDidMount() {
        this.setState({ elementeAfisate: this.props.elemente || [] })
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            elementeAfisate: nextProps.elemente || [],
        })
    }

  

    

    render() {
        return (
            <div className='pm-users-list-container'>


                <ul style={{ cursor: 'pointer', position: 'relative' }} className='pm-list-container'>
                    <li className='pm-list-item-user' >

                        <Grid container className='pm-list-container-avatar-head' >

                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar-head'>

                                <span className='pm-list-item-span-head'>{this.props.dict.proiecte.etapeProiect.zileCumulate}</span>

                            </Grid>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.proiecte.etapeProiect.data}</span>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.proiecte.etapeProiect.ore}</span>
                            </Grid>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.proiecte.etapeProiect.minute}</span>
                            </Grid>
                        


                        </Grid>

                    </li>

                    {
                        this.state.elementeAfisate.map((e, idx) => {
                            return (
                                <li className='pm-list-item-user' key={idx}  >

                                    <Grid style={{position:'relative'}} container className='pm-list-container-avatar'>

                                        <Grid  style={{ position: 'relative' }} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                            <div className='pm-list-borderleft'></div>

                                             <Switch
                                                className={e[this.props.onlyColumns.zile_cumulate] !== 1 ? '' : "pm-switch"}
                                                checked={e[this.props.onlyColumns.zile_cumulate] !== 1 ? false : true}
                                                onChange={() => { this.props.handleZileCumulate(e) }}
                                                value='companie'
                                            />
                                            

                                        </Grid>

                                        <Grid  item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                        <input className='pm-task-time-input' 
                                                type='date'
                                                disabled={e[this.props.onlyColumns.zile_cumulate] !==1 ? false : true}
                                                style={{backgroundColor:'transparent',
                                                        textAlign:'center'}}
                                                value={e[this.props.onlyColumns.data_introdusa] || ''}  
                                                onChange={(ev)=>{this.props.changeDate(e,ev)}} 
                                                onBlur={()=>{this.props.updateDate(e)}} />
                   
                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                        <input className='pm-task-time-input' 
                                                type='number'
                                                style={{backgroundColor:'transparent',
                                                        textAlign:'center'}}
                                                max='1000'
                                                value={e[this.props.onlyColumns.nr_ore] || ''}  
                                                onChange={(ev)=>{this.props.changeOre(e,ev)}} 
                                                onBlur={()=>{this.props.updateOre(e)}} />
                                        </Grid>
                                        <Grid style={{ borderRight: 'none' }} item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                        <input className='pm-task-time-input' 
                                                type='number'
                                                style={{backgroundColor:'transparent',
                                                        textAlign:'center'}}
                                                max='60' 
                                                value={e[this.props.onlyColumns.nr_minute] || ''}  
                                                onChange={(ev)=>{this.props.changeMinute(e,ev)}} 
                                                onBlur={()=>{this.props.updateMinute(e)}} />
                                        </Grid>

                                    <i onClick={()=>{this.props.deleteTimp(e)}} style={{color:'#dc1010'}} className='material-icons'>delete</i>
                                    
                                    </Grid>

                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class

